"use client";

import { WishlistProductsDocument } from "../generated/graphql";
import { isTransactionalClient } from "@/apiUtils/commonClientUtils";
import { getWishlistIdByLocale } from "@/apiUtils/commonUtils";
import { localeConstants } from "@/apiUtils/constants";
import { getFromCookieMetadataClient } from "@/apiUtils/cookieDataUtils";
import { getClientCookie } from "@/utils/common";
import { WishlistResponse } from "@/common/lib/types";
import PublicSaleorClient from "./PublicSaleorClient";

/**
 * Client-side function to get wishlisted products
 * @param first Number of items to fetch
 * @returns Promise<WishlistResponse | null>
 */
export async function getWishlistedProductsClient(first: number): Promise<WishlistResponse | null> {
  try {
    const saleorClient = new PublicSaleorClient();
    const locale = getClientCookie(localeConstants.NEXT_LOCALE) || "";

    try {
      const isTransactional = isTransactionalClient(locale);

      if (isTransactional) {
        const wishlistIdByLocale = getWishlistIdByLocale(locale);
        if (!wishlistIdByLocale) return null;
        const wishlistId = getFromCookieMetadataClient(wishlistIdByLocale);
        if (!wishlistId) return null;

        await saleorClient.init(locale);

        const response: { data: { wishlist: WishlistResponse }; errors: unknown } = await saleorClient.post(
          `${WishlistProductsDocument}`,
          {
            id: wishlistId,
            first,
          },
          "no-store",
        );

        if (response?.errors) {
          return null;
        }

        return response?.data?.wishlist || null;
      }
    } catch (error) {
      return null;
    }

    return null;
  } catch (error) {
    return null;
  }
} 